import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../../../media';

export const CardPriceWrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 8px;

	${breakpoints.only.mobile} {
		row-gap: 4px;
	}
`;

export const btnStyles = css`
	max-width: 86px;
`;
